/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BusinessLineFilter } from '../models/BusinessLineFilter';
import type { BusinessLineProfitContributionReport } from '../models/BusinessLineProfitContributionReport';
import type { OverheadCostsProfitContributionReportRow } from '../models/OverheadCostsProfitContributionReportRow';
import type { ProjectProfitContributionReport } from '../models/ProjectProfitContributionReport';
import type { StaffNumberProfitContributionReport } from '../models/StaffNumberProfitContributionReport';
import type { TotalProfitContributionReport } from '../models/TotalProfitContributionReport';
import type { WorkshopProfitContributionReport } from '../models/WorkshopProfitContributionReport';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ControllingProfitContributionReportService {
    /**
     * returns values by month
     * @param tenantId tenant_id
     * @param year year
     * @param view view
     * @param businessLine business_line
     * @returns StaffNumberProfitContributionReport successful
     * @throws ApiError
     */
    public static getStaffNumberProfitContributionReport(
        tenantId: string,
        year: number,
        view?: string,
        businessLine?: BusinessLineFilter,
    ): CancelablePromise<StaffNumberProfitContributionReport> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/controlling/profit_contribution_report/staff_number',
            path: {
                'tenant_id': tenantId,
            },
            query: {
                'year': year,
                'view': view,
                'business_line': businessLine,
            },
        });
    }
    /**
     * returns overhead costs for gmbh view
     * @param tenantId tenant_id
     * @param year year
     * @param view view
     * @returns OverheadCostsProfitContributionReportRow successful
     * @throws ApiError
     */
    public static getOverheadCostsProfitContributionReport(
        tenantId: string,
        year: number,
        view?: string,
    ): CancelablePromise<OverheadCostsProfitContributionReportRow> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/controlling/profit_contribution_report/overhead_costs',
            path: {
                'tenant_id': tenantId,
            },
            query: {
                'year': year,
                'view': view,
            },
        });
    }
    /**
     * returns values by month
     * @param tenantId tenant_id
     * @param year year
     * @param view view
     * @param staffNumber staff_number
     * @returns BusinessLineProfitContributionReport successful
     * @throws ApiError
     */
    public static getBusinessLineProfitContributionReport(
        tenantId: string,
        year: number,
        view?: string,
        staffNumber?: string,
    ): CancelablePromise<BusinessLineProfitContributionReport> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/controlling/profit_contribution_report/business_line',
            path: {
                'tenant_id': tenantId,
            },
            query: {
                'year': year,
                'view': view,
                'staff_number': staffNumber,
            },
        });
    }
    /**
     * returns values by month
     * @param tenantId tenant_id
     * @param year year
     * @param view view
     * @param businessLine business_line
     * @param staffNumber staff_number
     * @returns ProjectProfitContributionReport successful
     * @throws ApiError
     */
    public static getProjectProfitContributionReport(
        tenantId: string,
        year: number,
        view?: string,
        businessLine?: BusinessLineFilter,
        staffNumber?: string,
    ): CancelablePromise<ProjectProfitContributionReport> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/controlling/profit_contribution_report/project',
            path: {
                'tenant_id': tenantId,
            },
            query: {
                'year': year,
                'view': view,
                'business_line': businessLine,
                'staff_number': staffNumber,
            },
        });
    }
    /**
     * returns revenue by month and workshop
     * @param tenantId tenant_id
     * @param year year
     * @returns WorkshopProfitContributionReport successful
     * @throws ApiError
     */
    public static getWorkshopProfitContributionReport(
        tenantId: string,
        year: number,
    ): CancelablePromise<WorkshopProfitContributionReport> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/controlling/profit_contribution_report/workshop',
            path: {
                'tenant_id': tenantId,
            },
            query: {
                'year': year,
            },
        });
    }
    /**
     * returns values by month
     * @param tenantId tenant_id
     * @param year year
     * @param view view
     * @returns TotalProfitContributionReport successful
     * @throws ApiError
     */
    public static getTotalProfitContributionReport(
        tenantId: string,
        year: number,
        view?: string,
    ): CancelablePromise<TotalProfitContributionReport> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/controlling/profit_contribution_report/total',
            path: {
                'tenant_id': tenantId,
            },
            query: {
                'year': year,
                'view': view,
            },
        });
    }
    /**
     * exports actual by stuff number for analytics
     * @param tenantId tenant_id
     * @param year year
     * @param view view
     * @param businessLine business_line
     * @returns binary successful
     * @throws ApiError
     */
    public static exportProfitContributionReport(
        tenantId: string,
        year: number,
        view?: string,
        businessLine?: BusinessLineFilter,
    ): CancelablePromise<Blob> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/tenants/{tenant_id}/controlling/profit_contribution_report/export',
            path: {
                'tenant_id': tenantId,
            },
            query: {
                'year': year,
                'view': view,
                'business_line': businessLine,
            },
        });
    }
}
